export enum CancellationReason {
  CREDENCIAL_RASURADA= "Rasurada",
	CREDENCIAL_EM_COPIA= "Cópia Utilizada",
	USO_INDEVIDO= "Uso Indevido",
	ADULTERADA= "Adulterada",
	FALSIFICADA= "Falsificada",
	ROUBADA= "Roubada",
	PERDIDA= "Perdida",
	OUTROS= "Outros",
}
